<template>
	<div class="w-full relative">
		<span @click="openSearch = !openSearch" class="text-secondary-100 cursor-pointer">
			<i class="icon-magnifier text-xl"  aria-label="open" v-if="!openSearch"></i>
			<i class="fas fa-times text-xl"  aria-label="close" v-else></i>
		</span>
		<div class="flex flex-wrap items-stretch w-full  search-header " v-show="openSearch">
			<input type="text" id="search_input" v-model="search" v-on:keyup="SubmitForm" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-secondary-100 rounded ltr:rounded-r-none rtl:rounded-l-none px-3 relative focus:border-secondary-100 focus:outline-none focus:shadow inpt_search" :placeholder="t('search_placeholder')" />
			<div class="flex -mr-px">
				<button type="submit" @click="SubmitFormResult" class="flex items-center leading-normal bg-secondary-100 rounded ltr:rounded-l-none rtl:rounded-r-none border ltr:border-l-0 rtl:border-r-0 border-secondary-100 px-3 whitespace-no-wrap text-white text-sm">
					<i class="icon icon-magnifier"></i>
				</button>
			</div>
			<div v-show="showList" class="search-result absolute inset-x-0 top-100% bg-white p-4 rounded-b shadow-md" id="search_result">
				<ul>
					<li v-for="product in products">
						<div class="search-item">
							<a :href="product.route" class="flex flex-wrap my-2 justify-center">
								<div class="img w-16 h-16 border-primary border rounded-md p-2">
									<img :src="product.image" class="w-full h-full object-contain">
								</div>
								<div class="w-9/12 px-2 self-center text-sm">
									<p class="text-primary">{{ product.name }}</p>
									<p class="text-secondary-300 font-bold mt-1"> {{ product.price }}  ريال</p>
								</div>
							</a>
						</div>
					</li>
				</ul>
			</div>	
			
		</div>	
	</div>

</template>
<script>
import axios from 'axios';
import arabic from 'vee-validate/dist/locale/ar';
import { Validator , mapFields} from 'vee-validate';
import trans from './translation/user.json';
export default {
	name: "Search",
	props: {
		action: {
			type: String,
			required: true
		},
		sitelocale:{
			type: String,
			required: true
		},
		redirectRoute:{
			type: String,
			required: true
		}
	},
	data() {
		return {
			search:'',
			showList: false,
			products:[],
			openSearch:false
		};
	},
	mounted() {
		this.$translate.setLang(this.sitelocale);
	},
	locales: trans,
	created() {
		this.$validator.localize('ar', {
			messages: arabic.messages,
			attributes: trans.ar,
			custom:trans.ar.custom
		});
		this.$validator.localize('en', {
			custom:trans.en.custom
		});
		Validator.localize(this.sitelocale);
	},
	methods: {
		SubmitForm(){
			this.$validator.validateAll().then((result) => {
				if (result) {
					const action = this.action;
					if(this.search == '') {
						this.showList = false;
						this.success = false;
						this.products =[]
					} else {
						axios.get(action, {
							params : {'search' : this.search}
						})
						.then( response => {
							if(response.data.data.length > 0)
							{
								this.showList = true;
								this.success = true;
								this.products = response.data.data
							} else {
								this.showList = false;
								this.success = false;
								this.products =[]
							}
						})
						.catch(error => {
							let toaster = this.$toasted;
							$.each(error.response.data.errors, function(key, value) {
								toaster.error(value.message);
							});
							this.success = false;

						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});
					}
				}
			});
		},
		SubmitFormResult(){
			this.$validator.validateAll().then((result) => {
				if (result) {
					const action = this.action;
					if(this.search == '') {

					} else {
						axios.get(action, {
							params : {'search' : this.search}
						})
						.then( response => {
							window.location.href = this.redirectRoute+'?search='+this.search;
						})
						.catch(error => {
						});
					}
				}
			});
		}
	},
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/Search.vue